export default "__VITE_ASSET__9283be02__"